import { PeriodoFinalDirective } from './core/directives/periodo-final.directive';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ScrollingModule } from '@angular/cdk/scrolling';

import { registerLocaleData, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

/* Pacotes Externos */

import { BaseChartDirective, ThemeService, provideCharts, withDefaultRegisterables } from 'ng2-charts';

import {
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
  NgbModalModule,
  NgbNavModule,
  NgbProgressbarModule,
  NgbTimepickerModule,
  NgbTooltipModule,
  NgbTooltipConfig,
  NgbTypeaheadModule
} from '@ng-bootstrap/ng-bootstrap';

import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ToastrModule } from 'ngx-toastr';

/* Auth */

import { AuthGuard } from './core/guards/auth.guard';
import { AuthService } from './core/services/auth/auth.service';

/* Calendar */

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';

/* Conversão */

import { ConversaoService } from './core/tools/conversao.service';

/* Drag and Drop */

import { DndModule } from 'ngx-drag-drop';

/* Listener */

import { ListenerInterceptor } from './core/interceptors/listener-interceptor';
import { SessaoDiariaInterceptor } from './core/interceptors/sessao-diaria-interceptor';
import { ListenerService } from './core/services/listener/listener.service';

/* Maps */

import { GoogleMapsModule } from '@angular/google-maps';
import { MapaConfiguracao } from './core/tools/mapa-configuracao';

/* Split */

import { AngularSplitModule } from 'angular-split';

/* Tempo */

import { TempoProgressivoService } from './core/tools/tempo-progressivo.service';
import { TempoRegressivoService } from './core/tools/tempo-regressivo.service';

/* Componentes */

import { AppComponent } from './app.component';

import { AlterarSenhaComponent } from './components/alterar-senha/alterar-senha.component';
import { AlternarUsuarioComponent } from './components/alternar-usuario/alternar-usuario.component';
import { PedidoClienteBuscaComponent } from './components/pedidos-cadastro/cliente-busca/pedido-cliente-busca.component';
import { PedidoClienteSelecionadoComponent } from './components/pedidos-cadastro/cliente-selecionado/pedido-cliente-selecionado.component';
import { PedidoCabecalhoCamposComponent } from './components/pedidos-cadastro/cabecalho-campos/pedido-cabecalho-campos.component';
import { PedidoModalLocaisEntregaComponent } from './components/pedidos-cadastro/modal-locais-entrega/pedido-modal-locais-entrega.component';
import { PedidoModalNotasFiscaisComponent } from './components/pedidos-cadastro/modal-notas-fiscais/pedido-modal-notas-fiscais.component';
import { PedidoItensErroInlineComponent } from './components/pedido-adicionar-itens-modal/erro-inline/pedido-itens-erro-inline.component';
import { PedidoItensDetalhePainelComponent } from './components/pedido-adicionar-itens-modal/detalhe-painel/pedido-itens-detalhe-painel.component';
import { PedidoItensCatalogoComponent } from './components/pedido-adicionar-itens-modal/catalogo/pedido-itens-catalogo.component';
import { PedidoItensToolbarComponent } from './components/pedido-adicionar-itens-modal/toolbar/pedido-itens-toolbar.component';
import { PedidoItensPasso1ToolbarComponent } from './components/pedidos-cadastro/pedido-itens-passo1-toolbar/pedido-itens-passo1-toolbar.component';
import { PedidoItensResumoComponent } from './components/pedidos-cadastro/pedido-itens-resumo/pedido-itens-resumo.component';
import { PedidoItensPendenciaComponent } from './components/pedidos-cadastro/pedido-itens-pendencia/pedido-itens-pendencia.component';
import { PedidoItensTabelaComponent } from './components/pedidos-cadastro/pedido-itens-tabela/pedido-itens-tabela.component';
import { PedidosPendenciaVinculadosComponent } from './components/pedidos-cadastro/pedidos-pendencia-vinculados/pedidos-pendencia-vinculados.component';
import { PedidoItensIaPainelComponent } from './components/pedido-adicionar-itens-modal/ia-painel/pedido-itens-ia-painel.component';
import { PedidoItensModalCampanhaComponent } from './components/pedido-adicionar-itens-modal/modal-campanha/pedido-itens-modal-campanha.component';
import { PedidoItensModalLotesComponent } from './components/pedido-adicionar-itens-modal/modal-lotes/pedido-itens-modal-lotes.component';
import { PedidoItensModalTabelasComponent } from './components/pedido-adicionar-itens-modal/modal-tabelas/pedido-itens-modal-tabelas.component';
import { PedidoItensModalEstoqueLocalComponent } from './components/pedido-adicionar-itens-modal/modal-estoque-local/pedido-itens-modal-estoque-local.component';
import { PedidoItensModalFotosComponent } from './components/pedido-adicionar-itens-modal/modal-fotos/pedido-itens-modal-fotos.component';
import { PedidoItensModalInformacoesComponent } from './components/pedido-adicionar-itens-modal/modal-informacoes/pedido-itens-modal-informacoes.component';
import { AjustarPontuacaoComponent } from './components/ajustar-pontuacao/ajustar-pontuacao.component';
import { AutomacaoMensagensComponent } from './components/automacao-mensagens/automacao-mensagens.component';
import { AutomacaoMensagensCadastroComponent } from './components/automacao-mensagens-cadastro/automacao-mensagens-cadastro.component';
import { CallCenterComponent } from './components/call-center/call-center.component';
import { CallCenterDiscadorComponent } from './components/call-center-discador/call-center-discador.component';
import { CallCenterGerenciarDiscadorComponent } from './components/call-center-gerenciar-discador/call-center-gerenciar-discador.component';
import { CallCenterLigacaoComponent } from './components/call-center-ligacao/call-center-ligacao.component';
import { CallCenterMotivosPausaComponent } from './components/call-center-motivos-pausa/call-center-motivos-pausa.component';
import { CallCenterMotivosPausaCadastroComponent } from './components/call-center-motivos-pausa-cadastro/call-center-motivos-pausa-cadastro.component';
import { CallCenterNovaLigacaoComponent } from './components/call-center-nova-ligacao/call-center-nova-ligacao.component';
import { CentralAtendimentoComponent } from './components/central-atendimento/central-atendimento.component';
import { ConfiguracoesComponent } from './components/configuracoes/configuracoes.component';
import { ContasCorrentesComponent } from './components/contas-corrrentes/contas-correntes.component';
import { ClientesCadastroComponent } from './components/clientes-cadastro/clientes-cadastro.component';
import { ClientesComponent } from './components/clientes/clientes.component';
import { ContratosComponent } from './components/contratos/contratos.component';
import { CrmComponent } from './components/crm/crm.component';
import { CrmNegociosComponent } from './components/crm-negocios/crm-negocios.component';
import { CrmTarefasComponent } from './components/crm-tarefas/crm-tarefas.component';
import { DashboardAnaliseComparativaComponent } from './components/dashboard/dashboard-analise-comparativa/dashboard-analise-comparativa.component';
import { DashboardB2BGestaoComponent } from './components/dashboard/dashboard-b2b-gestao/dashboard-b2b-gestao.component';
import { DashboardControleClientesComponent } from './components/dashboard/dashboard-controle-clientes/dashboard-controle-clientes.component';
import { DashboardCallCenterComponent } from './components/dashboard/dashboard-call-center/dashboard-call-center.component';
import { DashboardCallCenterPainelGerencialComponent } from './components/dashboard/dashboard-call-center-painel-gerencial/dashboard-call-center-painel-gerencial.component';
import { DashboardContratosComponent } from './components/dashboard/dashboard-contratos/dashboard-contratos.component';
import { FiltroSelecaoComponent } from './components/dashboard/dashboard-oportunidades/filtro-selecao.component';
import { DashboardOportunidadesComponent } from './components/dashboard/dashboard-oportunidades/dashboard-oportunidades.component';
import { DashboardPromocoesComponent } from './components/dashboard/dashboard-promocoes/dashboard-promocoes.component';
import { DashboardQuilometragensDespesasComponent } from './components/dashboard/dashboard-quilometragens-despesas/dashboard-quilometragens-despesas.component';
import { DashboardResultadosComponent } from './components/dashboard/dashboard-resultados/dashboard-resultados.component';
import { DashboardObjetivosComponent } from './components/dashboard/dashboard-resultados/dashboard-objetivos.component';
import { DashboardVendaInternaComponent } from './components/dashboard/dashboard-venda-interna/dashboard-venda-interna.component';
import { DashboardVendaInternaGerencialComponent } from './components/dashboard/dashboard-venda-interna-gerencial/dashboard-venda-interna-gerencial.component';
import { DashboardVendaInternaWhatsappComponent } from './components/dashboard/dashboard-venda-interna-whatsapp/dashboard-venda-interna-whatsapp.component';
import { DashboardVisitasComponent } from './components/dashboard/dashboard-visitas/dashboard-visitas.component';
import { ImportacoesComponent } from './components/importacoes/importacoes.component';
import { ImportacoesClientesComponent } from './components/importacoes-clientes/importacoes-clientes.component';
import { ImportacoesProdutosComponent } from './components/importacoes-produtos/importacoes-produtos.component';
import { IntegracoesComponent } from './components/integracoes/integracoes.component';
import { ControleIntegracoesComponent } from './components/controle-integracoes/controle-integracoes.component';
import { IaConfigComponent } from './components/ia-config/ia-config.component';
import { KanbanConfigComponent } from './components/kanban-config/kanban-config.component';
import { KanbanDashboardComponent } from './components/kanban-dashboard/kanban-dashboard.component';
import { KanbanComponent } from './components/kanban/kanban.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoginComponent } from './components/login/login.component';
import { MotivosNaoVendaCadastroComponent } from './components/motivos-nao-venda-cadastro/motivos-nao-venda-cadastro.component';
import { MotivosNaoVendaComponent } from './components/motivos-nao-venda/motivos-nao-venda.component';
import { NavBarComponent } from './components/nav-bar/nav-bar.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PedidoAdicionarItensModalComponent } from './components/pedido-adicionar-itens-modal/pedido-adicionar-itens-modal.component';
import { PedidosCadastroComponent } from './components/pedidos-cadastro/pedidos-cadastro.component';
import { PedidosComponent } from './components/pedidos/pedidos.component';
import { PedidosEnviadosComponent } from './components/pedidos-enviados/pedidos-enviados.component';
import { PedidosNaoEnviadosComponent } from './components/pedidos-nao-enviados/pedidos-nao-enviados.component';
import { ProdutosCadastroComponent } from './components/produtos-cadastro/produtos-cadastro.component';
import { ProdutosComponent } from './components/produtos/produtos.component';
import { ProdutosCampanhasCadastroComponent } from './components/produtos-campanhas-cadastro/produtos-campanhas-cadastro.component';
import { ProdutosPromocoesCadastroComponent } from './components/produtos-promocoes-cadastro/produtos-promocoes-cadastro.component';
import { ProdutosAnaliseMargemComponent } from './components/produtos-analise-margem/produtos-analise-margem.component';
import { MargemReguaComponent } from './components/produtos-analise-margem/margem-regua.component';
import { RecuperarSenhaComponent } from './components/recuperar-senha/recuperar-senha.component';
import { RotasComponent } from './components/rotas/rotas.component';
import { VendedoresComponent } from './components/vendedores/vendedores.component';
import { VendedoresCadastroComponent } from './components/vendedores-cadastro/vendedores-cadastro.component';
import { WhatsappOficialConfigComponent } from './components/whatsapp-oficial-config/whatsapp-oficial-config.component';
import { WhatsappOficialComponent } from './components/whatsapp-oficial/whatsapp-oficial.component';
import { TextoComLinksComponent } from './components/shared/texto-com-links/texto-com-links.component';
import { WhatsAppGruposComponent } from './components/whatsapp-grupos/whatsapp-grupos.component';
import { WhatsappInnersacComponent } from './components/whatsapp-innersac/whatsapp-innersac.component';
import { WhatsappInstanciaComponent } from './components/whatsapp-instancia/whatsapp-instancia.component';
import { PedidosAtencaoComponent } from './components/pedidos-atencao/pedidos-atencao.component';
import { PedidosPendenciasComponent } from './components/pedidos-pendencias/pedidos-pendencias.component';
import { TabelaProdutosEditavelComponent } from './components/tabela-produtos-editavel/tabela-produtos-editavel.component';
import { TabelaClientesEditavelComponent } from './components/tabela-clientes-editavel/tabela-clientes-editavel.component';
import { TabelaVendedoresEditavelComponent } from './components/tabela-vendedores-editavel/tabela-vendedores-editavel.component';
import { PaginationComponent } from './components/shared/pagination/pagination.component';
import { VendedorTypeaheadComponent } from './components/shared/vendedor-typeahead/vendedor-typeahead.component';
import { PrazoPagamentoSelectComponent } from './components/shared/prazo-pagamento-select/prazo-pagamento-select.component';
import { PedidosRelatoriosComponent } from './components/pedidos-relatorios/pedidos-relatorios.component';
import { CadastroFreteComponent } from './components/cadastro-frete/cadastro-frete.component';

@NgModule({ declarations: [
        FiltroSelecaoComponent,
        /* Componentes */
        AppComponent,
        AlterarSenhaComponent,
        AlternarUsuarioComponent,
        PedidoClienteBuscaComponent,
        PedidoClienteSelecionadoComponent,
        PedidoCabecalhoCamposComponent,
        PedidoModalLocaisEntregaComponent,
        PedidoModalNotasFiscaisComponent,
        PedidoItensErroInlineComponent,
        PedidoItensDetalhePainelComponent,
        PedidoItensCatalogoComponent,
        PedidoItensToolbarComponent,
        PedidoItensPasso1ToolbarComponent,
        PedidoItensResumoComponent,
        PedidoItensPendenciaComponent,
        PedidoItensTabelaComponent,
        PedidoItensIaPainelComponent,
        PedidoItensModalCampanhaComponent,
        PedidoItensModalLotesComponent,
        PedidoItensModalTabelasComponent,
        PedidoItensModalEstoqueLocalComponent,
        PedidoItensModalFotosComponent,
        PedidoItensModalInformacoesComponent,
        AjustarPontuacaoComponent,
        AutomacaoMensagensComponent,
        AutomacaoMensagensCadastroComponent,
        CallCenterComponent,
        CallCenterDiscadorComponent,
        CallCenterGerenciarDiscadorComponent,
        CallCenterLigacaoComponent,
        CallCenterMotivosPausaComponent,
        CallCenterMotivosPausaCadastroComponent,
        CallCenterNovaLigacaoComponent,
        CentralAtendimentoComponent,
        ConfiguracoesComponent,
        ContasCorrentesComponent,
        ClientesCadastroComponent,
        ClientesComponent,
        ContratosComponent,
        CrmComponent,
        CrmNegociosComponent,
        CrmTarefasComponent,
        DashboardAnaliseComparativaComponent,
        DashboardB2BGestaoComponent,
        DashboardControleClientesComponent,
        DashboardCallCenterComponent,
        DashboardCallCenterPainelGerencialComponent,
        DashboardContratosComponent,
        DashboardOportunidadesComponent,
        DashboardPromocoesComponent,
        DashboardQuilometragensDespesasComponent,
        DashboardResultadosComponent,
        DashboardVendaInternaComponent,
        DashboardVendaInternaGerencialComponent,
        DashboardVendaInternaWhatsappComponent,
        DashboardVisitasComponent,
        ImportacoesComponent,
        ImportacoesClientesComponent,
        ImportacoesProdutosComponent,
        IntegracoesComponent,
        ControleIntegracoesComponent,
        IaConfigComponent,
        KanbanConfigComponent,
        KanbanDashboardComponent,
        KanbanComponent,
        LoaderComponent,
        LoginComponent,
        MotivosNaoVendaCadastroComponent,
        MotivosNaoVendaComponent,
        NavBarComponent,
        NotFoundComponent,
        PedidoAdicionarItensModalComponent,
        PedidosCadastroComponent,
        PedidosComponent,
        PedidosEnviadosComponent,
        PedidosNaoEnviadosComponent,
        ProdutosCadastroComponent,
        ProdutosComponent,
        ProdutosCampanhasCadastroComponent,
        ProdutosPromocoesCadastroComponent,
        ProdutosAnaliseMargemComponent,
        MargemReguaComponent,
        RecuperarSenhaComponent,
        RotasComponent,
        VendedoresComponent,
        VendedoresCadastroComponent,
        WhatsappOficialConfigComponent,
        WhatsappOficialComponent,
        WhatsappInnersacComponent,
        WhatsappInstanciaComponent,
        PedidosAtencaoComponent,
        PedidosPendenciasComponent,
        TabelaProdutosEditavelComponent,
        TabelaClientesEditavelComponent,
        TabelaVendedoresEditavelComponent,
        PaginationComponent,
        VendedorTypeaheadComponent,
        PrazoPagamentoSelectComponent,
        PedidosRelatoriosComponent,
        PedidosPendenciaVinculadosComponent,
        CadastroFreteComponent
    ],
    bootstrap: [AppComponent], imports: [PeriodoFinalDirective, TextoComLinksComponent, WhatsAppGruposComponent, BrowserModule, DashboardObjetivosComponent,
        BrowserAnimationsModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        ScrollingModule,
        /* Pacotes Externos */
        BaseChartDirective,
        NgxBootstrapMultiselectModule,
        NgbCollapseModule,
        NgbDatepickerModule,
        NgbDropdownModule,
        NgbModalModule,
        NgbNavModule,
        NgbProgressbarModule,
        NgbTimepickerModule,
        NgbTooltipModule,
        NgbTypeaheadModule,
        ToastrModule.forRoot({
            closeButton: true,
            progressBar: true,
            tapToDismiss: true,
            timeOut: 2400
        }),
        DndModule,
        GoogleMapsModule,
        AngularSplitModule,
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory
        })], providers: [
        CurrencyPipe,
        DatePipe,
        DecimalPipe,
        /* Pacotes Externos */
        ThemeService,
        provideCharts(withDefaultRegisterables()),
        NgbTooltipConfig,
        /* Auth */
        AuthGuard,
        AuthService,
        /* Listener */
        ListenerInterceptor,
        ListenerService,
        { provide: HTTP_INTERCEPTORS, useClass: ListenerInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: SessaoDiariaInterceptor, multi: true },
        /* Conversão */
        ConversaoService,
        /* Tempo */
        TempoProgressivoService,
        TempoRegressivoService,
        { provide: LOCALE_ID, useValue: "pt" },
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
